import React, { useEffect, useState } from "react"
import packageJSON from "../../package.json"
import KopyLogo from "../assets/kopy-logo.png"
import kopyLogo from "../assets/kopy-logo-square.png"

const Logo = (props) => {
	const { lessMargin } = props

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				marginTop: lessMargin ? "5rem" : "12.25rem",
				transition: "margin-top 0.8s",
			}}
		>
			<div style={{ display: "flex", alignItems: "start" }}>
				{/* <img src={KopyLogo} style={{ width: "8rem" }}/> */}
				<img
					style={{
						width: "2.5rem",
						height: "2.5rem",
						borderRadius: "0.4rem",
					}}
					src={kopyLogo}
				/>
				<img
					src={KopyLogo}
					style={{
						width: "8rem",
						height: "3rem",
						objectFit: "cover",
						objectPosition: "top",
						filter: "hue-rotate(6deg)",
					}}
				/>
				<p style={{ fontSize: "0.65rem", color: "#8e8e8e9" }}>
					{packageJSON.version}
				</p>
			</div>
		</div>
	)
}

export default Logo
